<template>
    <div>

        <div class="SubaccountManage">
        <h4>{{$t('i18n_sub_account_management')}}</h4>
        <el-form ref="form" :label-position="labelPosition" :model="QueryBuilder" label-width="80px" size="mini">
            <el-form-item :label="$t('i18n_account')">
                <el-input clearable v-model="QueryBuilder.code" :placeholder="$t('i18n_please_enter')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('i18n_Name')">
                <el-input clearable v-model="QueryBuilder.name" :placeholder="$t('i18n_please_enter')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('i18n_usage_status')">
                <el-select v-model="QueryBuilder.status" :placeholder="$t('i18n_please_choose')">
                    <el-option :label="$t('i18n_Enable')" value="Y"></el-option>
                    <el-option :label="$t('i18n_Disable')" value="N"></el-option>
                </el-select>
            </el-form-item>
            <el-button type="primary" style="margin-left:0px" @click="onSubmit()">{{$t('i18n_Inquiry')}}</el-button>
        </el-form>
        <el-button type="primary" style="margin:0 0 30px 30px; width: 180px" @click="addsubaccount()">{{$t('i18n_create_new_sub_account')}}</el-button>
        <el-table border
            :data="tableData" max-height="500px"
            tooltip-effect="dark" :header-cell-style="{background:'#F3F3F3'}"
            ref="multipleTable"
            style="width: 95%;margin-left:32px;margin-bottom:15px;">
            <el-table-column type="index" :label="$t('i18n_Serial_number')" width="60px" min-width="8%"></el-table-column>
            <el-table-column prop="code" :label="$t('i18n_User_Name')" min-width="10%"></el-table-column>
            <el-table-column prop="name" :label="$t('i18n_Name')" min-width="10%"></el-table-column>
            <el-table-column prop="mobilePhone" :label="$t('i18n_Phone_number')" min-width="10%"></el-table-column>
            <el-table-column prop="createTime" :label="$t('i18n_creation_time')" min-width="10%"></el-table-column>
            <el-table-column prop="roleName" :label="$t('i18n_Roles')" min-width="10%"></el-table-column>
            <el-table-column prop="roleName" :label="$t('i18n_Is_main_account')" min-width="10%">
                <template slot-scope="scope">
                        {{$t(scope.row.isAdmin == 'Y' ? 'i18n_yes' : 'i18n_no')}}
                </template>
            </el-table-column>
            <el-table-column prop="statuss" :label="$t('i18n_usage_status')" min-width="7%"></el-table-column>
            <el-table-column prop="operation" :label="$t('i18n_Operation')" min-width="10%">
              <template slot-scope="scope">
                <el-button @click="orderdetails(scope.row)" type="text" size="small">{{$t('i18n_edit')}}</el-button>
              </template>
            </el-table-column>
        </el-table>
        <div  class="panelBox" v-show="panelBox">
            <div class="panel">
                <i class="el-icon-circle-close close" @click="closePanel()"></i>
                <h4 v-if="addPanel">{{$t('i18n_Create_new_sub_account')}}</h4>
                <h4 v-else>{{$t('i18n_Modify_sub_account')}}</h4>
                <el-form ref="MessageForm" :label-position="labelPosition" :rules="rules" :model="MessageForm"
                :label-width="lang==='zh'?'80px':'130px'" size="mini" hide-required-asterisk>
                    <el-form-item :label="$t('i18n_Employee_Name')" prop="name">
                        <el-input v-model="MessageForm.name" :placeholder="$t('i18n_please_enter')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('i18n_User_Name')" prop="username">
                        <el-input v-model="MessageForm.username" :disabled="CodeDisabled" :placeholder="$t('i18n_please_enter')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('i18n_Password')" prop="pass">
                        <!-- <el-input v-model="MessageForm.password" type="password" placeholder="请输入"></el-input> -->
                        <el-input type="password" v-model="MessageForm.pass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('i18n_confirm_password')" prop="checkPass">
                        <!-- <el-input v-model="MessageForm.checkPass" type="password" placeholder="请输入"></el-input> -->
                        <el-input type="password" v-model="MessageForm.checkPass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('i18n_Phone_number')" prop="mobilePhone">
                        <el-input v-model="MessageForm.mobilePhone" :placeholder="$t('i18n_please_enter')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('i18n_Email')" >
                        <el-input v-model="MessageForm.email" :placeholder="$t('i18n_please_enter')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('i18n_Roles')">
                        <!--  prop="roleId" -->
                        <el-select v-model="MessageForm.roleId" :placeholder="addPls('i18n_Roles', 'select')">
                            <el-option :label="item.cnName" :value="item.id" v-for="(item ,index) in rolelist" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item :label="$t('i18n_Status')">
                        <!--  prop="roleId" -->
                        <el-select v-model="MessageForm.status" :placeholder="addPls('i18n_Status', 'select')">
                            <el-option :label="$t('i18n_Enable')" value="Y"></el-option>
                             <el-option :label="$t('i18n_Disable')" value="N"></el-option>

                        </el-select>
                    </el-form-item>
                    <el-row v-if="addPanel">
                        <el-button size="small" @click="ruleForm('MessageForm')">{{$t('i18n_Confirm_continue')}}</el-button>
                        <el-button size="small" @click="addaccount('MessageForm')">{{$t('i18n_Confirm')}}</el-button>
                    </el-row>
                    <el-row v-else>
                        <el-button size="small" @click="confirmChange()">{{$t('i18n_edit')}}</el-button>
                    </el-row>
                </el-form>
            </div>
        </div>
        </div>
    </div>



</template>
<script>
import qs from "qs";
import { addPls } from '@/utils/placeholderI18n'
export default {
    name:"SubaccountManage",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('i18n_please_enter_your_password')));
            } else {
                if (this.MessageForm.checkPass !== '') {
                    this.$refs.MessageForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            console.log(value);
            if (value === '') {
                callback(new Error(this.$t('i18n_Please_enter_your_password_again')));
            } else if (value !== this.MessageForm.pass) {
                callback(new Error(this.$t('i18n_two_entered_passwords_do_not_match!')));
            } else {
                callback();
            }
        };
        var isMobileNumber= (rule, value, callback) => {
            const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/
		    if (!value) {
		      return callback(new Error(this.$t('i18n_phone_number_cannot_be_empty')))
            }
            if (!phoneReg.test(value)) {
		      return callback(new Error(this.$t('i18n_Incorrect_phone_number_format')))
            }
            callback();
		    // setTimeout(() => {
		    //   if (!Number.isInteger(+value)) {
		    //     callback(new Error('请输入数字值'))
		    //   } else {
		    //     if (phoneReg.test(value)) {
		    //       callback()
		    //     } else {
		    //       callback(new Error('电话号码格式不正确'))
		    //     }
		    //   }
		    // }, 100)
        };
        return {
            CodeDisabled:false,//用户名禁用
            customerid:'',//用户id
            labelPosition: 'left',
            QueryBuilder: {//表单
                code: '',
                name:"",
                status:'Y'
            },
            MessageForm:{//form弹框表单数据
                name:"",
                username:"",
                pass:"",
                checkPass:"",
                mobilePhone:"",
                email:"",
                roleId:"",
                userId:"",
                status:''
            },
            rules: {
                name: [
                    { required: true, message: this.$t('i18n_please_type_your_name'), trigger: 'blur' }
                ],
                username: [
                    { required: true, message: this.addPls('i18n_User_Name', 'input'), trigger: 'blur' }
                ],
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
                mobilePhone: [
                    // { required: true, message: '请输入手机号', trigger: 'change' }
                    { required: true, message: this.addPls("i18n_Phone_number", 'input'), trigger: "blur" },
                    { validator: isMobileNumber, trigger: "blur" }
                ],
                email: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger:  'blur' }
                ],
                roleId: [
                    {  type: 'array',required: true, message: '请至少选择一个所属角色', trigger: 'blur' }
                ],
            },
            tableData:[
                // {
                //     code:"",
                //     name:"",
                //     mobilePhone:"",
                //     roleId:"",
                //     roleName:"",
                //     status:""
                // }
            ],
            panelBox:false,//弹框显示隐藏
            addPanel:true,//新建子账号
            codeid:"",
            statusid:'Y',
            userIdid:"",
            // recomposePanel:false,
            rolelist:[],//所属角色下拉列表
            createType: 1
        }
    },
    watch: {
    },
    computed: {
        lang() {
            return this.$store.state.lang
        }
    },
    methods: {
        onSubmit(){//点击查询
            this.getAllAccount()
        },
        addsubaccount() {//点击新建子账号
            this.panelBox = true;
            this.addPanel = true;
            this.userIdid ="";
            this.codeid="";
            this.CodeDisabled= false;
            this.MessageForm = {
                name:"",
                username:"",
                pass:"",
                checkPass:"",
                mobilePhone:"",
                email:"",
                roleId:"",
                userId:""
            };
            this.$refs.MessageForm.resetFields();//重置form表单
        },
        closePanel(){//关闭弹框
            this.panelBox = false;
        },
        orderdetails(data){//点击table修改
            console.log(data);
            this.CodeDisabled= true;
            this.userIdid = data.userId;
            this.codeid = data.code;
            this.editpersonal(data.userId);
            this.$refs.MessageForm.resetFields();//重置form表单
            this.panelBox = true;
            this.addPanel = false;
        },
        confirmChange(){//确认修改
            this.codeid = this.MessageForm.username;
            this.AddAmendAccount();
            this.panelBox = false;
        },
        addaccount(MessageForm){//确认新建
            // this.$refs[MessageForm].resetFields();
            this.$refs[MessageForm].validate((valid) => {
                if (valid) {
                    // console.log("成功")
                    this.xinjiansuccess();

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        xinjiansuccess(){//新建成功
            this.createType = 2
            // console.log(this.MessageForm)
            this.codeid = this.MessageForm.username;
            this.AddAmendAccount();
            // this.panelBox = false;
            // this.$refs[MessageForm].resetFields();
        },
        ruleForm(MessageForm) {//确认并继续新建
            this.createType = 1
            this.$refs[MessageForm].validate((valid) => {
                if (valid) {
                     this.codeid = this.MessageForm.username;
                     this.AddAmendAccount();

                    // this.xinjiansuccess();
                    // this.panelBox = true;
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        succeedwarning(data) {//成功新建子账户提醒
            this.$message({
                message: data,
                type: 'success'
            });
        },
        getRoleAlldata(){//所属角色所有的数据
            let params = {
                "roleName": "",
                "status":1
            };
            let that = this;
            that.axios.get(
                "/authorization/getSubAccountRoleList",
                {params}
            )
            .then((response)=> {
                // console.log(response.data.datas);//.data.datas
                that.rolelist = response.data.datas;
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        getAllAccount(){//获取全部子账户信息
            let data = {
                "code": this.QueryBuilder.code,
                "customerId": this.customerid,
                "name": this.QueryBuilder.name,
                "status": this.QueryBuilder.status
            };
            let that = this;
            that.axios.post(
                "/user/queryUserInfos",
                data
            )
            .then(function (response) {
                // console.log(response.data.datas);
                that.tableData = response.data.datas;
                for(var i=0;i<that.tableData.length;i++){
                    if(that.tableData[i].status == "Y"){
                        that.tableData[i].statuss = that.$t("i18n_Enable");
                    }else if(that.tableData[i].status == "N"){
                        that.tableData[i].statuss = that.$t("i18n_Disable");
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        AddAmendAccount(){//新增、修改子账户
        let  that = this
            let data = {
                "code": this.codeid,//用户code
                "customerId": this.customerid,
                "email": this.MessageForm.email,
                "mobilePhone": this.MessageForm.mobilePhone,
                "name": this.MessageForm.name,
                "password": this.MessageForm.checkPass,
                "roleId": this.MessageForm.roleId,//所属角色this.roleIdid
                "status": this.MessageForm.status,
                "userId": this.userIdid,
            };
            // console.log(data);
            this.axios.post(
                "/user/saveOrUpdateUserInfo",
                data
            )
            .then(response=> {

                if(response.data.code!= 200){
                    this.$message.info(response.data.message)

                    return
                }

                if(this.createType != 1){
                     this.panelBox = false;
                }
                this.$message.success(response.data.message)
                this.getAllAccount();
                // 成功后清空表单
                this.userIdid ="";
                        this.codeid="";
                        this.CodeDisabled= false;
                        this.MessageForm = {
                            name:"",
                            username:"",
                            pass:"",
                            checkPass:"",
                            mobilePhone:"",
                            email:"",
                            roleId:"",
                            userId:""
                        };
                this.$refs[MessageForm].resetFields();

                // console.log(response);
                // if(response.data.message == "成功"|| response.data.message == "success.msg"){
                //     this.succeedwarning("添加成功");
                //     this.getAllAccount();
                //     this.closePanel();
                // }else if(response.data.message == "修改成功"){
                //     this.succeedwarning("修改成功");
                //     this.getAllAccount();
                // }else if(response.data.message == "服务器异常"){
                //     this.succeedwarning("操作失败,原因未知");
                // }
                // this.succeedwarning(response.data.message);
            })
            .catch( error => {
                console.log(error);
                // this.$message.info(error.data.message)
            });
        },
        editpersonal(userId){//编辑用户信息获取
            let params = {
                "userId": userId,
            };
            // console.log(params);
            let that = this;
            that.axios.get(
                "/user/findUserInfoById/"+userId,
                {params}
            )
            .then((response)=> {
                // console.log(response.data.data);//.data.datas
                this.MessageForm = response.data.data;
                this.$set(this.MessageForm, 'pass', response.data.data.password);
                this.$set(this.MessageForm, 'checkPass', response.data.data.password);
                this.$set(this.MessageForm, 'username', response.data.data.code);
                // this.MessageForm.username = data.code;
                // this.MessageForm.mobilePhone = data.mobilePhone;
            })
            .catch(function (error) {
                console.log(error);
            });

        },
        addPls,
    },
    created () {
        let publics = JSON.parse(sessionStorage.getItem('Authorization'));
        this.customerid = publics.customerid;
    },
    mounted () {
        this.getRoleAlldata();
        this.getAllAccount();
    }
}
</script>

<style lang="scss" scoped>
.SubaccountManage{
    position: relative;
    /* width: 98%; */
    /* height: 685px; */
    /* margin: 30px; */
    /* margin-top: 12px; */
    box-sizing: border-box;
    overflow: hidden;
}
.SubaccountManage h4{
  width: 100%;
  height: 24px;
  padding-top: 25px;
  padding-left: 31px;
  font-size: 24px;
  font-family: "PingFang-SC-Bold";
  color: #343434;
}
.SubaccountManage .addClass{
    display: block;
    width: 150px;
    height: 40px;
    margin-top: 8px;
    margin-bottom: 21px;
    margin-left: 31px;
    background: #FFFFFF;
    color: $d2d-color-primary;
    border: 1px solid $d2d-color-primary;
    border-radius: 5px;
}
.SubaccountManage .addClass:hover{
    background: $d2d-color-primary;
    color: #fff;
}
/* 弹框 */
.SubaccountManage .panelBox{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 2;
}
.SubaccountManage .panelBox .panel{
    position: absolute;
    top: calc(50% - 290px);
    left: calc(50% - 260px);
    width: 520px;
    /* height: 600px; */
    background: #fff;
    border-radius: 10px;
}
.SubaccountManage .panelBox .panel i.close{
    position: absolute;
    top: 25px;
    right: 20px;
    font-size: 24px;
}
.SubaccountManage .panelBox .panel i:hover{
    color: #409EFF;
}
.SubaccountManage .panelBox .el-button--small, .SubaccountManage .panelBox .el-button--small.is-round{
    width: 175px;
    height: 40px;
    margin-right: 8px;
    color: $d2d-color-primary;
    border: 1px solid $d2d-color-primary;
    border-radius: 5px;
}
.SubaccountManage .panelBox .el-row{
    margin-left: 80px;
}
.SubaccountManage .panelBox .el-button--small:hover, 
.SubaccountManage .panelBox .el-button--small.is-round:hover{
    background: $d2d-color-primary;
    color: #fff;
}
/* element */
/* .SubaccountManage .panelBox .panel .el-button--small, .el-button--small.is-round{
    margin-left: 112px;
} */
.SubaccountManage .panelBox .el-form .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    width: 92%;
}
.SubaccountManage .el-form{
  margin-top: 30px;
  margin-left: 31px;
  margin-bottom: 10px;
}
.SubaccountManage .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
  width: 23%;
  height: 40px;
  margin-right: 5%;
  display: inline-block;
}
.SubaccountManage .el-form .el-input--mini .el-input__inner{
    height: 36px;
    line-height: 36px;
}
.SubaccountManage .el-button--primary{
  width: 102px;
  height: 36px;
  padding: 0;
  background: $d2d-color-primary;
  border-radius: 5px;
  border: none;
}
.SubaccountManage .el-table td, .el-table th{
    text-align: center;
}
/* table 滚动条 */
.SubaccountManage .el-table__body-wrapper::-webkit-scrollbar{
    width: 3px;
}
.SubaccountManage .el-table__body-wrapper::-webkit-scrollbar-thumb{
    border-radius: 2px;
    height: 50px;
    background: #409EFF;
}
.SubaccountManage .el-table__body-wrapper::-webkit-scrollbar-track{
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    background: #eee;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/SubaccountManage.vue